module.exports = __webpack_public_path__ + "img/filscap_logo.ca031df9.png";